module.exports = __webpack_public_path__ + "static/img/7.a4cba90.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/7.png
// module id = q5gw
// module chunks = 0